import ProductDescription from './ProductDescription'

const PlantMilkProduct = {
  ...ProductDescription,
  category: '55',
  subCategory: '',
  IsBroadband: true,
  MilkType: '',
  OtherMilkType: null,
  Flavor: '',
  Type: '',
  Size: '',
  Organic: false,
  MultiPackageType: false,
  MultiPackageCount: null,
  Sugar: '',
  SugarCertification: false,
  Calcium: '',
  CalciumCertification: false,
  Protein: '',
  ProteinCertification: false,
  VitaminA: '',
  VitaminACertification: false,
  VitaminD: '',
  VitaminDCertification: false,
  VitaminB12: '',
  VitaminB12Certification: false,
  Magnesium: '',
  MagnesiumCertification: false,
  Phosphorus: '',
  PhosphorusCertification: false,
  Potassium: '',
  PotassiumCertification: false,
  Riboflavin: '',
  RiboflavinCertification: false,
}

export default PlantMilkProduct
